import { makeAutoObservable } from 'mobx';
import ApiClient from '../api/ApiClient';
import AuthStore from './authStore';
import NotificationsStore from './notificationsStore';
import UserStore from './userStore';
import DateStore from './dateStore';
import AnalyticsStore from './analyticsStore';
import ApiClientProps from '../api/ApiClientProps';

export default class MainStore {
	authStore: AuthStore;
	userStore: UserStore;
	notificationsStore: NotificationsStore;
	apiClient: ApiClient;
	dateStore: DateStore;
	analyticsStore: AnalyticsStore;

	constructor(apiClient: ApiClientProps) {
		makeAutoObservable(this);
		
		this.apiClient = new ApiClient(apiClient, this);
		this.authStore = new AuthStore(this);
		this.userStore = new UserStore(this);
		this.notificationsStore = new NotificationsStore(this);
		this.dateStore = new DateStore(this);
		this.analyticsStore = new AnalyticsStore(this);

	}
}